import { ComponentProps } from 'react';
import { StyleSheet } from 'react-native';
import { Popable } from 'react-native-popable';
import * as Device from 'expo-device';

import { Text } from '../Text';
import { colors, spacing } from '../../theme';

export const HoverTextTooltip = ({ content, children, ...popableProps }: Props) => {
	return (
		<Popable
			style={styles.popable}
			backgroundColor={colors.primary}
			position="bottom"
			caret
			{...popableProps}
			content={
				<Text category="c1" align="center" style={styles.content}>
					{content}
				</Text>
			}
			action={Device.deviceType === Device.DeviceType.DESKTOP ? 'hover' : 'press'}
		>
			{children}
		</Popable>
	);
};

type Props = Omit<ComponentProps<typeof Popable>, 'content'> & { content: string };

const styles = StyleSheet.create({
	popable: {
		width: 'auto',
	},
	content: {
		color: colors.white,
		margin: spacing(),
	},
});
